import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state",
  "use": "icon-state-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-state\">\n<g id=\"icon-state_ing 2\">\n<g id=\"icon-state_ing\">\n<g id=\"icon-state_Vector\">\n<path id=\"icon-state_Vector_2\" d=\"M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z\" fill-opacity=\"0.5\" />\n<path id=\"icon-state_Vector_3\" d=\"M6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4Z\" />\n</g>\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol